module.exports = __webpack_public_path__ + "img/Chat_record-B.8586bef6.svg";